/** Qiyin so'z yulduzchasi (demo `hardBtn`): corner — kartochka burchagi, mini — ro'yxat qatori. */
import { useStore } from '../store';
import { toast } from '../lib/toast';
import { Ic } from './Icon';

export function HardBtn({ id, cls = '' }: { id: number; cls?: 'corner' | 'mini' | '' }) {
  const on = useStore((s) => (s.hm ?? []).includes(id));
  const toggle = useStore((s) => s.toggleHard);
  return (
    <button className={`hardbtn ${cls}`} aria-pressed={on} aria-label="Qiyin soʻz deb belgilash"
      onClick={(e) => { e.stopPropagation(); const now = toggle(id); toast(now ? 'Qiyin soʻzlarga qoʻshildi' : 'Qiyin soʻzlardan olindi'); }}>
      <Ic n="star" /><span>{on ? 'Qiyin' : 'Qiyin?'}</span>
    </button>
  );
}
